export const spriteUrl = "/assets/sprites/icons-payment.KUwnKYbGBr6ZUbnvAW3xZw.svg"

export type IconName =
  | "applepay"
  | "bank-transfer"
  | "credit-card"
  | "eps"
  | "giropay"
  | "ideal"
  | "klarna"
  | "mastercard"
  | "paypal"
  | "sepa"
  | "trustly"
  | "visa"
